import { useMemo } from 'react';
import { useAssistantTool } from '@assistant-ui/react';
import { useLocation } from 'react-router-dom';
import { DASHBOARD_ASSISTANT_RUNTIME_MODE } from '../constants';
import { EMPTY_TOOL_PARAMETERS } from '../lib/assistantToolSchemas';
import { createFrontendToolActionMessage } from '../lib/toolActionMessages';

export function useGetCurrentDashboardContextAction({
  currentFeature,
  dispatchActionMessage,
  organizationId,
  organizationName,
  routeContext,
  userContext,
}) {
  const location = useLocation();

  const tool = useMemo(
    () => ({
      toolName: 'get_current_dashboard_context',
      type: 'frontend',
      description:
        'Return the current dashboard route, feature, user, and organization context. Use this when the user asks about the current page or says "this page".',
      parameters: EMPTY_TOOL_PARAMETERS,
      execute: () => {
        const result = {
          runtimeMode: DASHBOARD_ASSISTANT_RUNTIME_MODE,
          currentFeature,
          route: {
            pathname: location.pathname,
            search: location.search || undefined,
            hash: location.hash || undefined,
            ...routeContext,
          },
          user: userContext,
          organization: {
            id: organizationId,
            name: organizationName,
            permissions: userContext?.permissions || [],
          },
          organizationName,
        };
        dispatchActionMessage?.(createFrontendToolActionMessage({
          actionType: 'context',
          content: `Checked current page${currentFeature ? `: ${currentFeature}` : ''}`,
          status: 'ok',
          toolName: 'get_current_dashboard_context',
          toolResult: result,
        }));
        return result;
      },
    }),
    [
      currentFeature,
      dispatchActionMessage,
      location.hash,
      location.pathname,
      location.search,
      organizationId,
      organizationName,
      routeContext,
      userContext,
    ],
  );

  useAssistantTool(tool);
}
